import async from '~/utils/async';
import RootStoreContext from '~/contexts/RootStoreContext';
import resolver from './Metrics.resolver';
import Metrics from './Metrics';

export default async(resolver, { context: RootStoreContext })(Metrics);
